var _window, _window2;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
// ----------------------------------------------------------------------------
// Library: Just-Validate
// ----------------------------------------------------------------------------
//
// Form validation library with pre-configured and custom settings.
// Refer to https://just-validate.dev/examples for additonal customization.
//
// Usage: Add the class 'form--validate' to a form.
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

import JustValidate from '@iamota/just-validate';
import JustValidatePluginDate from 'just-validate-plugin-date';
import iamotaEventHandler from 'scripts/helpers/iamota-event-handler';
import Debug from 'scripts/libs/debug';

// -------------------------------------
// Localize Validation Error Messages
// -------------------------------------

// Generate Just Validate "dictLocal" Object
// We'll consider everything "English", but Shopify will provide localized translations
var dictLocale = (_window = window) !== null && _window !== void 0 && (_window = _window.translations) !== null && _window !== void 0 && _window.formValidationErrors ? Object.keys((_window2 = window) === null || _window2 === void 0 || (_window2 = _window2.translations) === null || _window2 === void 0 ? void 0 : _window2.formValidationErrors) : [].map((key, value) => ({
  key,
  dict: {
    en: value
  }
}));

// -------------------------------------
// Functionality
// -------------------------------------

var initFormValidation = () => {
  var forms = document.querySelectorAll('.form--validate');
  forms.forEach(/*#__PURE__*/function () {
    var _ref = _asyncToGenerator(function* (form) {
      // Merge default settings with custom settings from data-just-validate
      var defaultSettings = {
        validateBeforeSubmitting: true,
        errorFieldStyle: '',
        // Style with CSS (i.e. no inline styles)
        errorLabelStyle: '' // Style with CSS (i.e. no inline styles)
      };
      var customSettings = form.getAttribute('data-just-validate');
      var settings = customSettings ? _objectSpread(_objectSpread({}, defaultSettings), JSON.parse(customSettings)) : defaultSettings;
      settings = yield iamotaEventHandler.applyFilters('formValidation:settings', settings, {
        form
      });

      // Initialize the Validator
      var validator = new JustValidate(form, settings, dictLocale);

      // Helper to loop over the form fields to define rules
      // let formRules = {};
      // const forEachField = (selector, callback) => {
      //     form.querySelectorAll(selector).forEach((field) => {
      //         const fieldName = field.getAttribute('name');
      //         if (!fieldName) return; // Abort if the field doesn't have a name
      //         if (!formRules[fieldName]) formRules[fieldName] = [];
      //         callback(field, fieldName);
      //     });
      // };

      // forEachField('input[required]', (field, fieldName) => {
      //     formRules[fieldName].push({ 'rule' : 'required' });
      // });

      // forEachField('input[type="email"]', (field, fieldName) => {
      //     formRules[fieldName].push({ 'rule' : 'email' });
      // });

      // forEachField('input[type="number"]', (field, fieldName) => {
      //     formRules[fieldName].push({ 'rule' : 'number' });
      // });

      // forEachField('input[maxlength]', (field, fieldName) => {
      //     formRules[fieldName].push({
      //         'rule' : 'maxLength',
      //         'value' : parseInt(field.getAttribute('maxlength'), 10)
      //     });
      // });

      // forEachField('input[minlength]', (field, fieldName) => {
      //     formRules[fieldName].push({
      //         'rule' : 'minLength',
      //         'value' : parseInt(field.getAttribute('minlength'), 10)
      //     });
      // });

      // forEachField('input[min]', (field, fieldName) => {
      //     formRules[fieldName].push({
      //         'rule' : 'minNumber',
      //         'value' : parseInt(field.getAttribute('min'), 10)
      //     });
      // });

      // forEachField('input[max]', (field, fieldName) => {
      //     formRules[fieldName].push({
      //         'rule' : 'maxNumber',
      //         'value' : parseInt(field.getAttribute('max'), 10)
      //     });
      // });

      // forEachField('input[type="file"][required]:not([data-min-files])', (field, fieldName) => {
      //     formRules[fieldName].push({
      //         'rule'         : 'minFilesCount',
      //         'value'        : 1,
      //         'errorMessage' : window?.translations?.formValidationErrors?.required
      //     });
      // });

      // forEachField('input[type="file"][multiple][data-min-files]', (field, fieldName) => {
      //     formRules[fieldName].push({
      //         'rule' : 'minFilesCount',
      //         'value' : parseInt(field.getAttribute('data-min-files'), 10)
      //     });
      // });

      // forEachField('input[type="file"][multiple][data-max-files]', (field, fieldName) => {
      //     formRules[fieldName].push({
      //         'rule' : 'maxFilesCount',
      //         'value' : parseInt(field.getAttribute('data-max-files'), 10)
      //     });
      // });

      // forEachField('input[pattern]', (field, fieldName) => {
      //     formRules[fieldName].push({
      //         'rule'         : 'customRegexp',
      //         'value'        : new RegExp(field.getAttribute('pattern')),
      //         'errorMessage' : field.getAttribute('data-pattern-error') || field.getAttribute('title') || window?.translations?.formValidationErrors?.customRegexp,
      //     });
      // });

      // forEachField('input[data-regex]:not([pattern])', (field, fieldName) => {
      //     formRules[fieldName].push({
      //         'rule'         : 'customRegexp',
      //         'value'        : new RegExp(field.getAttribute('data-regex')),
      //         'errorMessage' : field.getAttribute('data-regex-error') || field.getAttribute('title') || window?.translations?.formValidationErrors?.customRegexp,
      //     });
      // });

      // forEachField('input[name="date"], input[type="date"], [data-rule="date"]', (field, fieldName) => {
      //     formRules[fieldName].push({
      //         plugin: JustValidatePluginDate(() => ({
      //             format: 'yyyy-mm-dd',
      //         })),
      //         errorMessage: window?.translations?.formValidationErrors?.date,
      //     });
      // });

      // forEachField('input[type="tel"]:not([pattern]), [data-rule="phone"]:not([pattern])', (field, fieldName) => {
      //     formRules[fieldName].push({
      //         rule: 'customRegexp',
      //         value: /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/,
      //         errorMessage: window?.translations?.formValidationErrors?.phone_international,
      //     });

      //     // formRules[fieldName].push({
      //     //     rule: 'customRegexp',
      //     //     value: /^\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4}$/,
      //     //     errorMessage: window?.translations?.formValidationErrors?.phone_10digit,
      //     // });
      // });

      // // Register the Rules
      // Object.entries(formRules).forEach(([fieldName, rules]) => {
      //     if (rules.length > 0) {
      //         validator.addField(`[name="${fieldName}"]`, rules);
      //     }
      // });

      // Notify subscribers that the form was initialized
      iamotaEventHandler.trigger('formValidation:init', {
        validator,
        form
      }, {
        context: form,
        isAtomic: true
      }).then(() => {
        //Debug.details('Form Validation Initialized, triggering initial validation...', { form, validator });
        validator.revalidate();
      });
    });
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
};
document.addEventListener('DOMContentLoaded', () => {
  initFormValidation();
});